import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const PAYMENT_STEP = 2;

const CheckoutOrderingStepper = props => {
  const { activeStep, onAddressStepClick } = props;

  return (
    <div className="row">
      <div className="col-xs-16 col-sm-10 col-sm-offset-3">
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          classes={{
            root: 'ordering-steps-stepper'
          }}
        >
          <Step>
            <StepLabel>
              <FormattedMessageWrappedInSpan
                id="checkoutOrderingStepper.stepper.email"
                defaultMessage="Register"
              />
            </StepLabel>
          </Step>
          <Step onClick={activeStep === PAYMENT_STEP ? onAddressStepClick : null}>
            <StepLabel classes={{
              root: activeStep === PAYMENT_STEP && 'ordering-steps-label-action'
            }}>
              <FormattedMessageWrappedInSpan
                id="checkoutOrderingStepper.stepper.address"
                defaultMessage="Address"
              />
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              <FormattedMessageWrappedInSpan
                id="checkoutOrderingStepper.stepper.payment"
                defaultMessage="Payment"
              />
            </StepLabel>
          </Step>
        </Stepper>
      </div>
    </div>
  );
};

CheckoutOrderingStepper.propTypes = {
  activeStep: PropTypes.number,
  onAddressStepClick: PropTypes.func,
};

export default CheckoutOrderingStepper;
